import axios from 'axios';

import { Filter } from './Filter';
import { GetToken } from './Session';

export function GetOrder(q) {
	return axios.get('/api/v1/orders' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetInvoice(q) {
	return axios.get('/api/v1/invoices' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function CreateOrder(data) {
	return axios.post('/api/v1/orders', data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetOrderById(id) {
	return axios.get('/api/v1/orders/' + id, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function UpdateOrderById(id, data) {
	return axios.patch('/api/v1/orders/' + id, data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function DeleteOrderById(id) {
	return axios.delete('/api/v1/orders/' + id, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetOrderHistories(order_id) {
	return axios.get('/api/v1/order_histories?sorts=-created_at&invoice.id=' + order_id, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetOrderWaybill(order_id) {
	return axios.get(`/api/v1/orders/${order_id}/waybill`, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function UpdateOrderWaybill(order_id, data) {
	return axios.post(`/api/v1/orders/${order_id}/waybill`, data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetOrderSummaries(q) {
	return axios.get('/api/v1/invoice_summaries' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetXlsxOrderSummaries(q) {
	return axios.get('/api/v1/xlsx_order_summaries' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetXlsxTopCustomer(q) {
	return axios.get('/api/v1/xlsx_top_customer' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetXlsxAwaitingPreOrderSaleCustomer(q) {
	return axios.get('/api/v1/xlsx_awaiting_pre_order_sale_customers' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetXlsxTopProduct(q) {
	return axios.get('/api/v1/xlsx_top_product' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetPdfOrderSummaries(q) {
	return axios.get('/api/v1/pdf_order_summaries' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetPdfOrderDetails(q) {
	return axios.get('/api/v1/pdf_orders' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetXlsxOrderDetails(q) {
	return axios.get('/api/v1/xlsx_orders' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetAffiliateOrder(q) {
	return axios.get('/api/v1/affiliate_orders' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetAffiliateSummary(q) {
	return axios.get('/api/v1/affiliate_summaries' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function SetAffiliateSettlement(referral_code) {
	return axios.post(`/api/v1/affiliate_settlements`, { referral_code: referral_code }, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetXlsxAffiliateOrder(q) {
	return axios.get('/api/v1/xlsx_affiliate_orders' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetXlsxAffiliateSummary(q) {
	return axios.get('/api/v1/xlsx_affiliate_summaries' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}

export function GetProductSold(q) {
	return axios.get('/api/v1/product_solds' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetVoucherByCode(code) {
	return axios.get('/api/v1/vouchers/' + code, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetReviews(q) {
	return axios.get('/api/v1/reviews' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function SetReviews(data) {
	return axios.post('/api/v1/reviews', data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}
